import { render, staticRenderFns } from "./Cate.vue?vue&type=template&id=4fca304b&scoped=true&"
import script from "./Cate.vue?vue&type=script&lang=js&"
export * from "./Cate.vue?vue&type=script&lang=js&"
import style0 from "./Cate.vue?vue&type=style&index=0&id=4fca304b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fca304b",
  null
  
)

export default component.exports